import React from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import { useMemo } from "react";
import { DialogContent, Grid } from "@material-ui/core";
import accessoriesService from "../../../services/accessories.service";

const initialValues = {
  name: "",
  colorId: undefined,
  colorValue: "",
  count: 0,
  price: 0,
  isActive: true,
  images: [],
};
const schema = Yup.object().shape({
  name: yupSchema.name,
  colorId: yupSchema.colorId,
  price: yupSchema.priceMin,

  // image
  // price
  // modelObject
  // frontImage
  // sideImage
  // threeQuarterImage
  // modelImage
  // isActive

  // TODO: schema
});

const FormWrapper = ({ children }) => (
  <DialogContent>
    <Grid container spacing={2}>
      {children}
    </Grid>
  </DialogContent>
);

export default function FormModalContent({ close, data, extra, parent }) {
  const errorHandler = useErrorHandler();

  const form = useMemo(
    () => [
      {
        _type: "container",
        name: "col1",
        _wrapper: (props) => <Grid item sm={7} md={6} xs={12} {...props} />,
        form: [
          {
            _type: "textField",
            name: "name",
            label: "نام",
            autoFocus: true,
          },
          {
            _type: "autocomplete",
            _empty: undefined,
            name: "colorId",
            options: extra?.colors || [],
            label: "رنگ",
            disableClearable: true,
            valueSelector: "id",
            labelSelector: "name",
          },
          {
            _type: "textField",
            name: "colorValue",
            label: "کد رنگ",
          },
          {
            _type: "filePicker",
            name: "image",
            label: "تصویر رنگ",
            isImage: true,
          },
        ],
      },
      {
        _type: "container",
        name: "col2",
        _wrapper: (props) => <Grid item sm={5} md={6} xs={12} {...props} />,
        form: [
          {
            _type: "textField",
            name: "price",
            type: "currency",
            label: "قیمت",
            inputProps: {
              min: 0,
            },
          },
          {
            _type: "textField",
            name: "count",
            type: "number",
            label: "موجودی",
            inputProps: {
              min: 0,
            },
          },
          {
            _type: "filePicker",
            name: "images",
            label: "تصاویر",
            isImage: true,
            multiple: true,
          },
          {
            _type: "switch",
            name: "isActive",
            label: "فعال",
          },
        ],
      },
    ],
    [extra]
  );

  const handleSubmit = async (model, { setSubmitting }) => {
    let op;
    if (data?.id) {
      op = await accessoriesService.editAccessoryColor(data.id, model);
    } else {
      op = await accessoriesService.createAccessoryColor({
        ...model,
        accessoryId: parent.id,
      });
    }
    const { error } = op;
    setSubmitting(false);
    if (error) return errorHandler(error);

    close(true);
  };
  return (
    <DialogFormBuilder
      {...{
        close,
        name: "رنگ اکسسوری",
        data,
        schema,
        initialValues,
        handleSubmit,
        form,
        formWrapper: FormWrapper,
      }}
    />
  );
}
